export default __webpack_public_path__ + "static/media/menu-icon-mobile.35b25456.svg";